export default __webpack_public_path__ + "static/media/support.74bae8e9.svg";